import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 1.5C3.86 1.5.5 4.87.5 9s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5S12.14 1.5 8 1.5zm0 1c2.23 0 4.21 1.13 5.38 2.86H2.62A6.514 6.514 0 0 1 8 2.5zM3.28 6.36h9.44L8 14.29 3.28 6.36zM1.5 9c0-.96.21-1.87.59-2.69l5.46 9.16C4.17 15.24 1.5 12.43 1.5 9zm6.95 6.48 5.46-9.17c.38.82.59 1.73.59 2.69 0 3.43-2.67 6.24-6.05 6.48z"
    }, null, -1)
  ])))
}
export default { render };